import { render, staticRenderFns } from "./EditableOrder.vue?vue&type=template&id=4c25b734&scoped=true&"
import script from "./EditableOrder.vue?vue&type=script&lang=js&"
export * from "./EditableOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditableOrder.vue?vue&type=style&index=0&id=4c25b734&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25b734",
  null
  
)

export default component.exports